"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const wpackio_1 = require("@lyfter/wpackio");
new wpackio_1.VueApp([
    require.context('../php/Blocks', true, /\.vue$/i),
    require.context('./components', true, /\.vue$/i),
    require.context('../php/Blocks', true, /\.vue$/i),
]);
const select_all_and_run_1 = require("./utils/select-all-and-run");
const _favoriteVacancy_1 = require("./functions/_favoriteVacancy");
(0, _favoriteVacancy_1.initAddToFavorite)();
(0, select_all_and_run_1.SelectAllAndRun)('.swiper-logo-slider', async (elements) => {
    const { Slider } = await Promise.resolve().then(() => __importStar(require(
    /* webpackChunkName: "carousel" */
    './class/LogoSlider')));
    new Slider(elements);
});
(0, select_all_and_run_1.SelectAllAndRun)('.references-swiper', async (elements) => {
    const { ReferencesSlider } = await Promise.resolve().then(() => __importStar(require(
    /* webpackChunkName: "carousel" */
    './class/ReferencesSlider')));
    new ReferencesSlider(elements);
});
